import { render, staticRenderFns } from "./SegmentPricing.vue?vue&type=template&id=90f2af20&lang=pug&"
import script from "./SegmentPricing.vue?vue&type=script&lang=js&"
export * from "./SegmentPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports